module.exports = __webpack_public_path__ + "static/img/Logo Talmud_Search_White_Circle.7e44e2ed.png";